import api from './api';

export const listAssessments = async (params = {}) => {
  const { data } = await api.get('/assessments', { params });
  return data;
};

export const getAssessment = async (id) => {
  const { data } = await api.get(`/assessments/${id}`);
  return data;
};

export const createAssessment = async (payload) => {
  const formData = new FormData();
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if ((key === 'attachments' || key === 'memo') && Array.isArray(value)) {
      value.forEach((file) => formData.append(key, file));
    } else if (key === 'quiz' && typeof value === 'object') {
      formData.append('quiz', JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  });
  const { data } = await api.post('/assessments', formData);
  return data;
};

export const updateAssessment = async (id, payload) => {
  const formData = new FormData();
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if ((key === 'attachments' || key === 'memo') && Array.isArray(value)) {
      value.forEach((file) => formData.append(key, file));
    } else if (key === 'quiz' && typeof value === 'object') {
      formData.append('quiz', JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  });
  const { data } = await api.put(`/assessments/${id}`, formData);
  return data;
};

export const deleteAssessment = async (id) => {
  const { data } = await api.delete(`/assessments/${id}`);
  return data;
};

export default {
  listAssessments,
  getAssessment,
  createAssessment,
  updateAssessment,
  deleteAssessment,
};
